// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"Modal_CloseButton__3CTaL","Page":"Modal_Page__1aEJZ","Button":"Modal_Button__2i917"};